/**
 * The platforms a link can point at — the vocabulary behind the Link-in-Bio picker, the stored
 * `icon` key on a manual row, and the key `AutoLinkCatalog` emits for a derived row. Backend and
 * frontend agree on the KEY only; the label and grouping are presentation and live here.
 *
 * `custom` is the deliberate escape hatch (and the default for a new row): a link with no platform
 * identity still gets a glyph, so no row ever renders iconless.
 */
export type PlatformGroup = "Streaming" | "Social" | "Other";

export interface PlatformDef {
  /** Stored verbatim in `artist.band_links.icon` — never renamed once shipped. */
  key: string;
  label: string;
  group: PlatformGroup;
}

export const PLATFORMS: readonly PlatformDef[] = [
  { key: "spotify", label: "Spotify", group: "Streaming" },
  { key: "apple", label: "Apple Music", group: "Streaming" },
  { key: "youtube", label: "YouTube", group: "Streaming" },
  { key: "tidal", label: "Tidal", group: "Streaming" },
  { key: "amazon", label: "Amazon Music", group: "Streaming" },
  { key: "pandora", label: "Pandora", group: "Streaming" },
  { key: "bandcamp", label: "Bandcamp", group: "Streaming" },
  { key: "soundcloud", label: "SoundCloud", group: "Streaming" },
  { key: "instagram", label: "Instagram", group: "Social" },
  { key: "tiktok", label: "TikTok", group: "Social" },
  { key: "threads", label: "Threads", group: "Social" },
  { key: "facebook", label: "Facebook", group: "Social" },
  { key: "x", label: "X", group: "Social" },
  { key: "discord", label: "Discord", group: "Social" },
  { key: "twitch", label: "Twitch", group: "Social" },
  { key: "custom", label: "Custom", group: "Other" },
];

export const PLATFORM_GROUPS: readonly PlatformGroup[] = ["Streaming", "Social", "Other"];

export const platformLabel = (key: string | null | undefined): string =>
  PLATFORMS.find((p) => p.key === key)?.label ?? "Custom";
